module.exports = __webpack_public_path__ + "static/img/Jaydn-Sua.abb4ed9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jaydn-Sua.jpg
// module id = K73q
// module chunks = 0